import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { UiBsTranslateService } from '@wlp/ui-bs-translate';
import { LayoutConfigModel } from 'src/app/core/layout/models/layout-config.model';

import { LayoutConfigService } from './../../../../../core/layout/services/layout-config.service';

@Component({
  selector: 'app-modal-pix-management-key',
  templateUrl: './modal-pix-management-key.component.html',
  styleUrls: ['./modal-pix-management-key.component.scss'],
})
export class ModalPixManagementKeyComponent {
  public succeed: boolean;
  @Input() title: string;
  @Input() subtitle: string;
  @Input() dismissText: string;
  @Input() confirmText: string;
  @Input() doubleButton = true;
  @Input() clearButton: boolean;
  @Input() imageModal: boolean;
  @Input() imageTag: string;
  @Input() params?: Object;

  private langDefault: string;
  private layoutConfigValue: LayoutConfigModel;

  constructor(
    public modalController: ModalController,
    private layoutConfigService: LayoutConfigService,
    private translate: UiBsTranslateService
  ) {

    this.layoutConfigValue = this.layoutConfigService.getSavedConfig();
    this.langDefault = this.layoutConfigValue.wlTheme.languageDefault;
    this.translate.setDefaultLang(this.langDefault);
    this.succeed = true;
  }

  public toggleSucceed(): void {
    this.succeed = !this.succeed;
  }

  async dismiss() {
    this.modalController.dismiss({
      dismissed: true,
    });
  }

  async confirm() {
    this.modalController.dismiss({
      dismissed: false,
    });
  }

  showImage() {
    if (this.imageModal) {
      return this.getImageTag(this.imageTag);
    } else {
      return '';
    }
  }

  public getImageTag(tag: string) {
    let item: any = this.layoutConfigService.getImagesPages(tag);
    return item.path;
  }
}
